<script setup lang="ts">
import { vIntersectionObserver } from '@vueuse/components'

const showProviders = ref(false)

function animateInProviders([{ isIntersecting }]: IntersectionObserverEntry[]) {
    if (!isIntersecting || showProviders.value) return
    showProviders.value = true
}

const providers = [
    {
        src: '/media/landing-page/provider/evolution.png',
        alt: 'Evolution',
    },
    {
        src: '/media/landing-page/provider/red-tiger.png',
        alt: 'Red Tiger',
    },
    {
        src: '/media/landing-page/provider/netent.png',
        alt: 'Netent',
    },
    {
        src: '/media/landing-page/provider/btg.png',
        alt: 'BTG',
    },
    {
        src: '/media/landing-page/provider/nolimit-city.png',
        alt: 'Nolimit City',
    },
    {
        src: '/media/landing-page/provider/pragmatic-play.png',
        alt: 'Pragmatic Play',
    },
]
</script>

<template>
    <section
        v-intersection-observer.once="[animateInProviders, { threshold: 0.1 }]"
        class="providers container container--lg"
        :class="{ 'animate-in': showProviders }"
    >
        <div
            v-for="provider in providers"
            :key="provider.alt"
            class="provider"
        >
            <NuxtImg
                provider="cloudflare"
                preset="local"
                :src="provider.src"
                :alt="provider.alt"
                sizes="xs:100px md:132px"
                width="100"
                loading="lazy"
                decoding="async"
            />
        </div>
    </section>
</template>

<style scoped lang="scss">
.providers {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 15px;
    gap: 10px;
    margin-top: 50px;
    margin-bottom: 100px;
}

.provider {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25%;
    height: 60px;
    padding: 8px 15px;
    border-radius: 14px;
    opacity: 0;
    transform: translate3d(0, 80px, 0);
    background: rgb(255 255 255 / 10%);
    backface-visibility: hidden;
    will-change: transform, opacity;
    transition:
        opacity 0.3s ease,
        transform 1s ease-out;

    @media (min-width: $screen-sm) {
        height: 64px;
    }

    @media (min-width: $screen-sm-md) {
        border-radius: 20px;
        width: 132px;
        height: 80px;
    }

    img {
        width: auto;
        height: auto;
        max-height: 100%;
        max-width: 100%;
    }

    @for $i from 1 through 8 {
        &:nth-child(#{$i}) {
            transition-delay: (40ms * $i);
        }
    }

    .animate-in & {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }
}
</style>
